import { render, staticRenderFns } from "./dangerMaster.vue?vue&type=template&id=67179dd4"
import script from "./dangerMaster.vue?vue&type=script&lang=js"
export * from "./dangerMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67179dd4')) {
      api.createRecord('67179dd4', component.options)
    } else {
      api.reload('67179dd4', component.options)
    }
    module.hot.accept("./dangerMaster.vue?vue&type=template&id=67179dd4", function () {
      api.rerender('67179dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerMaster.vue"
export default component.exports